import { useCallback } from 'react';


import { getCombinedLinkFieldValueHref } from '@eneco/common/link';
import { useRouter } from '@eneco/next';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-react';

export type QueryParams = Partial<Record<string, string | number | boolean | undefined | null>>;
export type LinkType = LinkFieldValue | string;
interface Props {
  link?: LinkType;
  queryParams?: QueryParams;
}

export const createQueryString = (queryParams?: QueryParams) => {
  if (!queryParams) {
    return '';
  }
  const params = new URLSearchParams();
  Object.entries(queryParams)
    .filter(([, value]) => value != null)
    .forEach(([key, value]) => {
      params.append(key, String(value));
    });
  return params.toString();
};
export const useRedirect = () => {
  const router = useRouter();

  const redirect = useCallback(
    ({ queryParams, link }: Props) => {
      if (!link) return;
      const queryString = createQueryString(queryParams);
      if (typeof link === 'string') {
        const querySuffix = queryString ? `?${queryString}` : '';
        window.location.href = `${link}${querySuffix}`;
        return;
      }
      const linkValue = { ...link, querystring: link.querystring ?? '' };
      if (queryString) {
        linkValue.querystring = linkValue.querystring ? `${linkValue.querystring}&${queryString}` : `${queryString}`;
      }
      const href = getCombinedLinkFieldValueHref(linkValue);

      if (linkValue.linktype === 'external') {
        window.location.href = href;
        return;
      }

      router.push(href);
    },
    [router],
  );

  return redirect;
};
